import { Col, Progress, Row, Tooltip } from 'antd';
import { Rule } from 'antd/lib/form';
import React, { ReactElement } from 'react';
import { GUTTOR_SPACE } from '../../constants/commonConstants';
import { EXTENDED_STATUS, progress, UPLOAD_STATUS } from '../../constants/crmConstants';
import { ReactComponent as CloseIcon } from '../../../assets/images/svg/HIS_Cross_Remove_Icon.svg';
import { ReactComponent as FileIcon } from '../../../assets/images/svg/HIS_File_Icon.svg';
import { UploadFile } from 'antd/lib/upload/interface';
import { submitAdmission } from '../../../store/actions/fileAction';
import { useDispatch } from 'react-redux';
import { centeredNotification } from '../../../utils/utility';
import { getFileType } from '../../../utils/fileUploadUtils';
import { formatDocumentUploadedDate } from '../../../modules/crm/inPatient/service/crmUtils';

function HisBuddhiMedUploadListItem({ file, key, index, onRemove, fileListLength, newUploads,
  fileLimit, showPreviouslyAddedFiles, fileList }: any): ReactElement {
  const dispatch = useDispatch();
  const rules: Rule[] = [];
  const [progress33, progress66, progress100] = progress;

  rules.push({ required: true });
  const { existingRecord, name, createdDate, status, extendedStatus, fileType = [], uid, uploadedOn } = file;
  const onDownload = (aFile: UploadFile): any => {
    const { response } = aFile;
    if (response) {
      const { errorMsg, uploadedDetails, isSuccess } = response;
      if (isSuccess) {
        const { fileGuid, fileName } = uploadedDetails[0];
        centeredNotification(`${fileName} start downloading...`, 'success');
        dispatch(submitAdmission(fileGuid));
      } else {
        centeredNotification(errorMsg);
      }
    }
  };
  let customPercent = 0;
  if (status === UPLOAD_STATUS.uploading) {
    customPercent = progress33;
  } else if (status === UPLOAD_STATUS.done) {
    customPercent = (extendedStatus === EXTENDED_STATUS.verified
      || extendedStatus === EXTENDED_STATUS.uploaded || (!extendedStatus && status === UPLOAD_STATUS.done)) ? progress100 : progress66;
  }

  const bytesToMB = (sizeInBytes: any): any => {
    const sizeInMB = sizeInBytes / (1024 * 1024);
    // Round to 3 decimal places and format it
    const formattedSizeInMB = sizeInMB?.toFixed(3);

    // Return the formatted size in MB
    return `${formattedSizeInMB} MB`;
  };

  return (
    <div className="upload-list-HIS">
      <Row gutter={GUTTOR_SPACE} className="margin-10 HIS-new-uploads-container">
        <Col md={5} className="padding-10">
          <div className="text-elipsis">
            <FileIcon className="fill-gray v-align-middle" /> &nbsp;
            <span className="His-filename">
              <a onClick={(): void => onDownload(file)} className="His-filename">
                <Tooltip placement="right" title={name?.length > 16 ? name : null} mouseEnterDelay={0.8}>
                  {name}
                </Tooltip>
              </a>
            </span>
          </div>
        </Col>
        <Col md={5} className="His-filesize his-uploaded-on padding-18">
          {formatDocumentUploadedDate(createdDate || uploadedOn)}
        </Col>
        <Col md={5} className="His-filesize his-size padding-18">
          {bytesToMB(file?.size) || fileLimit}
        </Col>
        <Col md={1} className="circular-progress his-progress-icon padding-18">
          {<Progress type="circle" percent={customPercent} width={20} strokeColor="#2ABF86" />}
        </Col>
        {
          <Col md={4} className="His-filename his-document-classification">
            {
              getFileType(fileType)
            }
          </Col>
        }
        <Col span={3} className="padding-25 remove-action-icon">
          {!existingRecord ? <Tooltip title="Remove"><CloseIcon data-testid={`${file.uid}-remove`} className="fill-close v-align-middle mouse-pointer"
            onClick={(): void => onRemove(uid)} /></Tooltip> : null}
        </Col>
      </Row>
    </div>
  );
}

export default HisBuddhiMedUploadListItem;
